import * as Const from '../../costants'

import { authFetch } from '../cookie/Cookie'

export async function getProfessioni (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum (
        Const.PROFESSIONI_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getSesso (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum (
        Const.SESSO_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getStati (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum (
        Const.STATI_URL,
        callback,
        expiredSessionCallbak
    )
}


export async function getDispositiviSmart (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.DISPOSITIVI_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.DISPOSITIVI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getFasciaPrezzi (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.FASCIA_PREZZI_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.FASCIA_PREZZI_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getAlimentazioneBarca (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.ALIMENTAZIONE_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.ALIMENTAZIONE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoAssicurazioneBarca (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.ASSICURAZIONE_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.ASSICURAZIONE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoUtilizzoBarca (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.UTILIZZO_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.UTILIZZO_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getRegioni (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.REGIONI_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.REGIONI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getLuoghi (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.LUOGHI_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.LUOGHI_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getUtilizziCasa (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.UTILIZZO_CASA_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.UTILIZZO_CASA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipiCasa (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.TIPO_CASA_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.TIPO_CASA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAnniCasa (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.ANNO_CASA_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.ANNO_CASA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getMaterialiCasa (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.MATERIALI_CASA_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.MATERIALI_CASA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getStatiCasa (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    if (Const.STATO_CASA_URL === '#') {
        return Promise.reject()
    }

    return getEnum (
        Const.STATO_CASA_URL,
        callback,
        expiredSessionCallbak
    )
}


export async function getTipiAnimaili (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum (
        Const.TIPO_ANIMALI_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getAreaProfessionale (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_AREA_PROFESSIONALE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAreaGiuridica (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_AREA_GIURIDICA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAreaMedica (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_AREA_MEDICA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAreaTecnica (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_AREA_TECNICA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getDirezioneSanitarie (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_DIREZIONE_SANITARIA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getMassimali (
    areaProfessionale: string | undefined,
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum (
        (
            areaProfessionale !== undefined
                ? Const.TIPO_MASSIMALE_URL + '/' + areaProfessionale 
                : Const.TIPO_MASSIMALE_URL
        ),
        callback,
        expiredSessionCallbak
    )
}
export async function getRegime (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_REGIME_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getRetroattivita (
    areaProfessionale: string | undefined,
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        (
            areaProfessionale !== undefined
                ? Const.TIPO_RETROATTIVITA_URL + '/' + areaProfessionale 
                : Const.TIPO_RETROATTIVITA_URL
        ),
        callback,
        expiredSessionCallbak
    )
}
export async function getRisarcimenti (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_RISARCIMENTI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAssicurazioni (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_TIPO_ASSICURAZIONE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getProfessionisti (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_TIPO_PROFESSIONISTA_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAltreAssicurazioni (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_ALTRE_ASSICURAZIONI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getAttivitaChirurgica (
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {
    return getEnum(
        Const.TIPO_ATTIVITA_CHIRURGICA_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoCopertura(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_COPERTURA_TRAVEL_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoDestinazione(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_DESTINAZIONE_TRAVEL_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoDurata(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_DURATA_TRAVEL_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoNumero_figli(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_NUMERO_FIGLI_TRAVEL_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoPersona(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_PERSONA_TRAVEL_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoViaggio(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_VIAGGIO_TRAVEL_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoSport(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_SPORT_INJURY_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoTutelatiSalute(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_TUTELATI_SALUTE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoTuteleSalute(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_TUTELE_SALUTE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoRedditoSalute(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_REDDITO_SALUTE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoSituazioniSalute(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_SITUAZIONI_SALUTE_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoMalattie(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_MALATTIA_SALUTE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipiVeicoloCommerciale(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_VEICOLO_COMMERCIALE_URL,
        callback,
        expiredSessionCallbak
    )
}


export async function getTipoBicicletta(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_BICI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoParcheggioBici(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_PARCHEGGIO_BICI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getTipoUtilizzoBici(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_USO_BICI_URL,
        callback,
        expiredSessionCallbak
    )
}
export async function getFasciaPrezzoBici(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.FASCIA_PREZZO_BICI_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoMicroCar(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_MICROCAR_URL,
        callback,
        expiredSessionCallbak
    )
}


export async function getTipoVeicoloEreditaCu(
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_VEICOLO_EREDITA_CU_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoAlimentazione (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_ALIMENTAZIONE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoMarce (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_MARCE_VEICOLO_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoStatoAssicurativo (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_STATO_ASSICURATIVO_URL,
        callback,
        expiredSessionCallbak
    )
}


export async function getFruizioneEredita (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_EREDITA_CU_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoCuEreditata (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_CU_EREDITATA_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoCuAttuale (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_CU_ATTUALE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipoAnzianitaPrimaClasse (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_ANZIANITA_PRIMA_CLASSE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getCompagnieAttuali (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_COMPAGNIA_ATTUALE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getEtaAssicurativa (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_ETA_ASSICURATIVA_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getAnniIncidenti (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_ANNO_INCIDENTE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getResponsabilitaIncidenti (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_RESPONSABILITA_INCIDENTE_URL,
        callback,
        expiredSessionCallbak
    )
}

export async function getTipiRelazionePersone (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.TIPO_RELAZIONI_PERSONE_URL,
        callback,
        expiredSessionCallbak
    )
}

//

async function getEnum (
    url: string,
    callback: Function,
    expiredSessionCallbak: Function
) : Promise<{}> {

    return authFetch (
        url,
        {
            method: 'get'
        },
        expiredSessionCallbak
    )
    .then((result : any ) => {      
        return callback?.(result)
    })
    .catch(err => {
        return callback?.(
            {} // empty result
        )
    })

}

export async function getProfessionByArea ( 
    choiceArea: string,
    expiredSessionCallbak: Function
) : Promise<{}>{
    return authFetch (
        Const.PROFESSIONE_BY_AREA_URL,
        {
            method: 'post',
            body: JSON.stringify({
                area: choiceArea
            })
        },
        expiredSessionCallbak
    )
}

export async function getAllProfessionByArea (
    callback: Function,
    expiredSessionCallbak: Function
) {
    return getEnum (
        Const.ALL_PROFESSIONE_BY_AREA_URL,
        callback,
        expiredSessionCallbak
    )
}

export type BaseEnumType = {id: string, value: string}